document.addEventListener('DOMContentLoaded', function () {
  // Initialize only if the element exists
    const swiperEl = document.querySelector('.mySwiper');
    if (swiperEl) {
      new Swiper('.mySwiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: '#swiper-button-prev-cultivation',
          prevEl: '#swiper-button-next-cultivation',
        }
      });
    }

    const featureSwiperEl = document.querySelector('.feature__blocks--slider');
    if (featureSwiperEl) {
      new Swiper('.feature__blocks--slider', {
        slidesPerView: 5,
        spaceBetween: 40,
        loop: false,
        navigation: {
          nextEl: featureSwiperEl.querySelector('.swiper-button-next'),
          prevEl: featureSwiperEl.querySelector('.swiper-button-prev'), 
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            575: {
              slidesPerView: 2,
            },
            767: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            992: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
          },
      });
    }

    $('.video-list .swiper-thumbnails swiper-slide').on('click', function () {
      // Find index of the clicked thumbnail
      const index = $(this).index();

      // Move main slider to that index
      const mainSwiper = document.querySelector('.video-list .container > swiper-container').swiper;
      mainSwiper.slideTo(index);

      setTimeout(() => {
          // Click the play button inside the corresponding main slide
          const mainSlides = document.querySelectorAll('.video-list .container > swiper-container swiper-slide');
          const targetSlide = mainSlides[index];

          if (!targetSlide) return;

          const playButton = targetSlide.querySelector('img');

          if (playButton) playButton.click();
      }, 150);
    });

  //   // -------------------------------
  // // THUMBNAIL CLICK → GO TO SLIDE + PLAY
  // // -------------------------------
  // $('.video-list .swiper-thumbnails swiper-slide').on('click', function () {
  //     console.log('clicked thumbnail');

  //     const index = $(this).index();

  //     // Main Swiper instance
  //     const mainSwiper = document.querySelector('.video-list .container > swiper-container').swiper;

  //     mainSwiper.slideTo(index);

  //     setTimeout(() => {
  //         const mainSlides = document.querySelectorAll('.video-list .container > swiper-container swiper-slide');
  //         const targetSlide = mainSlides[index];

  //         if (!targetSlide) return;

  //         // Reset video before clicking play
  //         const video = targetSlide.querySelector('video');
  //         if (video) {
  //             video.pause();
  //             video.currentTime = 0;
  //         }

  //         // Click play button (image)
  //         const playButton = targetSlide.querySelector('img');
  //         if (playButton) {
  //             playButton.click();
  //         }
  //     }, 150);
  // });


  // // -------------------------------
  // // SLIDE CHANGE → RESET ALL VIDEOS + PLAY ACTIVE SLIDE
  // // -------------------------------
  // const mainSwiperEl = document.querySelector('.video-list .container > swiper-container');

  // mainSwiperEl.addEventListener('swiperslidechange', function (e) {
  //     const swiper = e.target.swiper;

  //     // Reset ALL videos on slide change
  //     const allVideos = mainSwiperEl.querySelectorAll('video');
  //     allVideos.forEach(video => {
  //         video.pause();
  //         video.currentTime = 0;
  //     });

  //     // Play video in active slide
  //     const activeSlide = swiper.slides[swiper.activeIndex];
  //     const activeVideo = activeSlide.querySelector('video');

  //     if (activeVideo) {
  //         activeVideo.currentTime = 0;
  //         activeVideo.play();
  //     }
  // });

  // Show/hide the details under variants titles on the click of it
  $('.main-product__variant-selector .button--pill input').on('click', function() {
      $('.main-product__variant-selector .button--pill table').addClass('unchecked-hide');
      $('.main-product__variant-selector .button--pill .stock').addClass('unchecked-hide');

      $(this).parents('.button--pill').find('table').removeClass('unchecked-hide');
      $(this).parents('.button--pill').find('.stock').removeClass('unchecked-hide');
  });

  // Set the max height amoung all the product cards to the card title
  const feature_cards = document.querySelectorAll('swiper-container .card.card--product');

  if (feature_cards.length > 0) {
    let maxHeight = 0;

    // Step 1: Get tallest title
    feature_cards.forEach(card => {
      const content = card.querySelector('.card__content .card__title');
      if (content) {
        const h = content.offsetHeight;
        maxHeight = Math.max(maxHeight, h);
      }
    });

    // Step 2: Apply tallest height
    feature_cards.forEach(card => {
      const contents = card.querySelectorAll('.card__content .card__title');
      contents.forEach(item => {
        item.style.minHeight = maxHeight + 'px';
      });
    });
  }

    // const feature_cards_article = document.querySelectorAll('swiper-container .card.card--article');

    // if (feature_cards_article.length > 0) {
    //   console.log('iffff 1');

    //   let maxHeight = 0;

    //   // Step 1: Get tallest title
    //   feature_cards_article.forEach(card => {
    //     const content = card.querySelector('.card__content .card__title');
    //     if (content) {
    //       const h = content.offsetHeight;
    //       maxHeight = Math.max(maxHeight, h);
    //       console.log('maxHeight', maxHeight);
    //     }
    //   });

    //   // Step 2: Apply tallest height
    //   feature_cards_article.forEach(card => {
    //     const contents = card.querySelectorAll('.card__content .card__title');
    //     contents.forEach(item => {
    //       console.log('item 2', item);
    //       item.style.minHeight = maxHeight + 'px';
    //     });
    //   });
    // }

    // Set the max height amoung all the product cards to the card title for Collection page
    const feature_cards_grid = document.querySelectorAll('#ProductGridContainer .card');

    if (feature_cards_grid.length > 0) {

      let maxHeight = 0;

      // Step 1: Get tallest title
      feature_cards_grid.forEach(card => {
        const content = card.querySelector('.card__content .card__title');
        if (content) {
          const h = content.offsetHeight;
          maxHeight = Math.max(maxHeight, h);
        }
      });

      // Step 2: Apply tallest height
      feature_cards_grid.forEach(card => {
        const contents = card.querySelectorAll('.card__content .card__title');
        contents.forEach(item => {
          item.style.minHeight = maxHeight + 'px';
        });
      });
    }

    // video slider main video play button click

    // const mainPoster = document.getElementById('mainPoster');
    // const mainPosterImg = document.getElementById('mainPosterImg');
    // const mainPlayBtn = document.getElementById('mainPlayBtn');
    // const mainPlayer = document.getElementById('mainPlayer');

    // // initial values taken from poster container attributes
    // let currentVideo = mainPoster.getAttribute('data-video');
    // let currentType = mainPoster.getAttribute('data-type') || guessTypeFromUrl(currentVideo);

    // // helpers to render players
    // // function renderVimeo(src, autoplay = true) {
    // //   const sep = src.includes('?') ? '&' : '?';
    // //   const iframeSrc = src + (autoplay ? (sep + 'autoplay=1') : '') + '&muted=1';
    // //   mainPlayer.innerHTML = `<iframe id="mainVideo" src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    // //   showPlayer();
    // // }

    // function renderVimeo(src, autoplay = true) {
    //   let videoId = null;

    //   try {
    //     if (src.includes('vimeo.com/')) {
    //       videoId = src.split('vimeo.com/')[1].split(/[?&]/)[0];
    //     }
    //   } catch (e) { /* ignore */ }

    //   // If ID extracted, use proper embed format
    //   if (videoId) {
    //     const iframeSrc = `https://player.vimeo.com/${videoId}?${autoplay ? 'autoplay=1&' : ''}muted=1`;
    //     mainPlayer.innerHTML = `
    //       <iframe id="mainVideo" src="${iframeSrc}"
    //         frameborder="0"
    //         allow="autoplay; fullscreen"
    //         allowfullscreen>
    //       </iframe>`;
    //     showPlayer();
    //     return;
    //   }

    //   // Fallback for unusual Vimeo URLs
    //   const sep = src.includes('?') ? '&' : '?';
    //   const iframeSrc = `https://player.vimeo.com/${src}${sep}${autoplay ? 'autoplay=1&' : ''}muted=1`;

    //   mainPlayer.innerHTML = `
    //     <iframe id="mainVideo" src="${iframeSrc}"
    //       frameborder="0"
    //       allow="autoplay; fullscreen"
    //       allowfullscreen></iframe>`;
    //   showPlayer();
    // }

    // function renderYouTube(src, autoplay = true) {
    //   // get id if possible
    //   let videoId = null;
    //   try {
    //     if (src.includes('youtu.be/')) videoId = src.split('youtu.be/')[1].split(/[?&]/)[0];
    //     else if (src.includes('v=')) videoId = (new URL(src)).searchParams.get('v');
    //     else if (src.includes('youtube.com/embed/')) videoId = src.split('youtube.com/embed/')[1].split(/[?&]/)[0];
    //   } catch (e) { /* ignore */ }

    //   if (!videoId) {
    //     const sep = src.includes('?') ? '&' : '?';
    //     const iframeSrc = src + (autoplay ? (sep + 'autoplay=1&mute=1') : '') + '&enablejsapi=1';
    //     mainPlayer.innerHTML = `<iframe id="mainVideo" src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    //     showPlayer();
    //     return;
    //   }
    //   const iframeSrc = `https://www.youtube.com/embed/${videoId}?${autoplay ? 'autoplay=1&' : ''}mute=1&enablejsapi=1`;
    //   mainPlayer.innerHTML = `<iframe id="mainVideo" src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    //   showPlayer();
    // }

    // function renderHosted(src, autoplay = true) {
    //   // if autoplay true, include autoplay attribute; note some browsers may block unmuted autoplay
    //   const mutedAttr = autoplay ? 'muted' : '';
    //   mainPlayer.innerHTML = `
    //     <video id="mainVideo" class="main-video-element" playsinline ${autoplay ? 'autoplay' : ''} ${mutedAttr} controls style="width:100%;height:100%;object-fit:cover;">
    //       <source src="${src}" type="video/mp4">
    //       Your browser does not support the video tag.
    //     </video>
    //   `;
    //   showPlayer();
    //   // try to unmute if allowed (best-effort)
    //   const vid = mainPlayer.querySelector('video');
    //   if (vid && autoplay) {
    //     vid.play().catch(()=>{});
    //   }
    // }

    // function showPlayer() {
    //   // hide poster, show player
    //   mainPoster.classList.add('fade-out');
    //   setTimeout(() => {
    //     mainPoster.style.display = 'none';
    //     mainPlayer.style.display = 'block';
    //   }, 260);
    // }

    // function guessTypeFromUrl(url) {
    //   if (!url) return 'hosted';
    //   const low = url.toLowerCase();
    //   if (low.includes('vimeo.com')) return 'vimeo';
    //   if (low.includes('youtube.com') || low.includes('youtu.be')) return 'youtube';
    //   if (low.match(/\.(mp4|webm|ogv)(\?|$)/)) return 'hosted';
    //   return 'hosted';
    // }

    // // Main play button click (plays currentVideo)
    // mainPlayBtn.addEventListener('click', function (e) {
    //   e.preventDefault();
    //   if (!currentVideo) return;
    //   const type = currentType || guessTypeFromUrl(currentVideo);
    //   if (type === 'vimeo') renderVimeo(currentVideo, true);
    //   else if (type === 'youtube') renderYouTube(currentVideo, true);
    //   else renderHosted(currentVideo, true);
    // });

    // // Thumbnail clicks: update poster and autoplay video immediately
    // document.querySelectorAll('.video-thumb').forEach(thumb => {
    //   thumb.addEventListener('click', function (e) {
    //     e.preventDefault();
    //     const url = thumb.getAttribute('data-video');
    //     const type = thumb.getAttribute('data-type') || guessTypeFromUrl(url);
    //     const poster = thumb.getAttribute('data-poster') || thumb.querySelector('img')?.getAttribute('src');

    //     // update poster image & current video
    //     if (poster) {
    //       mainPosterImg.src = poster;
    //     }
    //     currentVideo = url;
    //     currentType = type;

    //     // autoplay on thumb click
    //     if (currentVideo) {
    //       if (currentType === 'vimeo') renderVimeo(currentVideo, true);
    //       else if (currentType === 'youtube') renderYouTube(currentVideo, true);
    //       else renderHosted(currentVideo, true);
    //     }
    //   }, { passive: true });
    // });


    // // Initialize Swiper
    // if (typeof Swiper !== 'undefined') {
    //   new Swiper('.video-thumbs', {
    //     slidesPerView: 3,
    //     spaceBetween: 24,
    //     centeredSlides: false,
    //     loop: false,
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev'
    //     },
    //     breakpoints: {
    //       0: { slidesPerView: 1, spaceBetween: 16 },
    //       768: { slidesPerView: 2, spaceBetween: 20 },
    //       992: { slidesPerView: 3, spaceBetween: 24 }
    //     }
    //   });
    // }

    // Video slider section - Play the main slider's video on the click of thubnail's poster click
    document.querySelectorAll('.video-slider').forEach(section => {

    const mainPoster = section.querySelector('#mainPoster');
    const mainPosterImg = section.querySelector('#mainPosterImg');
    const mainPlayBtn = section.querySelector('#mainPlayBtn');
    const mainPlayer = section.querySelector('#mainPlayer');
    // initial values
    let currentVideo = mainPoster.getAttribute('data-video');
    let currentType = mainPoster.getAttribute('data-type') || guessTypeFromUrl(currentVideo);

    /** ---------- PLAYER RENDER FUNCTIONS ---------- **/
    function renderVimeo(src, autoplay = true) {
      let videoId = null;
      try {
        if (src.includes('vimeo.com/')) {
          videoId = src.split('vimeo.com/')[1].split(/[?&]/)[0];
        }
      } catch (e) {}
      if (videoId) {
        const iframeSrc = `https://player.vimeo.com/${videoId}?${autoplay ? 'autoplay=1&' : ''}muted=1`;
        mainPlayer.innerHTML = `
          <iframe src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        `;
        showPlayer();
        return;
      }
      const sep = src.includes('?') ? '&' : '?';
      const iframeSrc = `https://player.vimeo.com/${src}${sep}${autoplay ? 'autoplay=1&' : ''}muted=1`;
      mainPlayer.innerHTML = `
        <iframe src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      `;
      showPlayer();
    }

    function renderYouTube(src, autoplay = true) {
      let videoId = null;
      try {
        if (src.includes('youtu.be/')) videoId = src.split('youtu.be/')[1].split(/[?&]/)[0];
        else if (src.includes('v=')) videoId = (new URL(src)).searchParams.get('v');
        else if (src.includes('youtube.com/embed/')) videoId = src.split('youtube.com/embed/')[1].split(/[?&]/)[0];
      } catch (e) {}
      if (!videoId) {
        const sep = src.includes('?') ? '&' : '?';
        const iframeSrc = src + (autoplay ? (sep + 'autoplay=1&mute=1') : '') + '&enablejsapi=1';
        mainPlayer.innerHTML = `<iframe src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
        showPlayer();
        return;
      }
      const iframeSrc = `https://www.youtube.com/embed/${videoId}?${autoplay ? 'autoplay=1&' : ''}mute=1&enablejsapi=1`;
      mainPlayer.innerHTML = `<iframe src="${iframeSrc}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      showPlayer();
    }

    function renderHosted(src, autoplay = true) {
      const mutedAttr = autoplay ? 'muted' : '';
      mainPlayer.innerHTML = `
        <video class="main-video-element" playsinline ${autoplay ? 'autoplay' : ''} ${mutedAttr} controls style="width:100%;height:100%;object-fit:cover;">
          <source src="${src}" type="video/mp4">
        </video>
      `;
      showPlayer();
    }

    function showPlayer() {
      mainPoster.classList.add('fade-out');
      setTimeout(() => {
        mainPoster.style.display = 'none';
        mainPlayer.style.display = 'block';
      }, 260);
    }

    /** ------------- HELPERS ------------- **/
    function guessTypeFromUrl(url) {
      if (!url) return 'hosted';
      const low = url.toLowerCase();
      if (low.includes('vimeo.com')) return 'vimeo';
      if (low.includes('youtube.com') || low.includes('youtu.be')) return 'youtube';
      if (low.match(/\.(mp4|webm|ogv)(\?|$)/)) return 'hosted';
      return 'hosted';
    }

    /** ------------- MAIN POSTER CLICK ------------- **/
    mainPlayBtn.addEventListener('click', e => {
      e.preventDefault();
      if (!currentVideo) return;
      const type = currentType || guessTypeFromUrl(currentVideo);
      if (type === 'vimeo') renderVimeo(currentVideo);
      else if (type === 'youtube') renderYouTube(currentVideo);
      else renderHosted(currentVideo);
    });

    /** ------------- THUMBNAIL CLICKS ------------- **/
    section.querySelectorAll('.video-thumb').forEach(thumb => {
      thumb.addEventListener('click', e => {
        e.preventDefault();
        const url = thumb.dataset.video;
        const type = thumb.dataset.type || guessTypeFromUrl(url);
        const poster = thumb.dataset.poster || thumb.querySelector('img')?.src;
        if (poster) mainPosterImg.src = poster;
        currentVideo = url;
        currentType = type;
        if (type === 'vimeo') renderVimeo(currentVideo);
        else if (type === 'youtube') renderYouTube(currentVideo);
        else renderHosted(currentVideo);
      });
    });

    /** ------------- SWIPER INSTANCE FOR THIS SECTION ------------- **/
    if (typeof Swiper !== 'undefined') {

      const thumbsEl = section.querySelector('.video-thumbs');
      if (thumbsEl) {
        new Swiper(thumbsEl, {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
          loop: false,
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 16 },
            768: { slidesPerView: 2, spaceBetween: 20 },
            992: { slidesPerView: 3, spaceBetween: 24 }
          }
        });
      }
    }
  });

  // Set the top position of sticky ATC based on it's height
  const bar = document.querySelector(".sticky-add-to-cart__inner");

  function updateHeight() {
    const h = bar.offsetHeight + "px";
    document.documentElement.style.setProperty("--sticky-height", h);
  }

  if (bar) {
    window.addEventListener("resize", updateHeight);
    setTimeout(() => {
      updateHeight();
    }, 300);
  }

  document.addEventListener("click", function (e) {
    // e.preventDefault();
    if (e.target.closest(".scroll-to-top")) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  });

});
